import { render } from "./Evidence.vue?vue&type=template&id=464a69e6&scoped=true"
import script from "./Evidence.vue?vue&type=script&lang=js"
export * from "./Evidence.vue?vue&type=script&lang=js"

import "./Evidence.vue?vue&type=style&index=0&id=464a69e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464a69e6"]])

export default __exports__